<template>
    <div class="b1t-okraina-main-menu-icons">
        <div class="container">

            <div class="scrollable">

                <div class="items">
                    <div class="item" 
                        v-for="item in items" 
                        :key="item.FIELDS.ID" 
                        @click="onItemClick(item)"
                        >

                        <div class="circle" v-bind:class="item.PROPS.SHAPE.XML_ID.toLowerCase()" >
                            <img :src='item.FIELDS.PREVIEW_PICTURE.SRC'/>
                        </div>

                        <div class="name">{{item.FIELDS.NAME}}</div>

                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'b1t-okraina-main-menu-icons',

        data() {
            return {
                items: [
                   
                ],
            }
        },
        computed: {

        },
        methods: {
            load() {
                return axios(this.$store.state.apiUrl + '/rest/system.menu.icons', {
                    method: "GET"
                }).then((response) => {
                    this.items = response.data.ITEMS;
                    return response;
                }).catch((error) => {
                    return error;
                })
            },
            onItemClick(item) {

                switch (item.PROPS.TYPE.XML_ID) {
                    case "CATALOG":
                        this.$router.push({ name: 'catalog', params: { }})
                        break;
                    case "CALL":
                        window.open("tel:+7 (8152) 78 88 88");
                        break;
                    case "PAGE":
                        this.$router.push({ name: 'page', params: { url: item }})
                        break;
                    default:
                        break;
                }
            }
        },
        mounted(){
            this.load();
        }
        
    }
</script>

<style lang="scss">

    .b1t-okraina-main-menu-icons {
        padding-bottom: 5px;
        padding-top:20px;
        background: #f4f4f4;
        

        .scrollable {
            margin: 0px -15px;

            overflow: hidden;

        }

        .items {

            text-align: center;
           
            white-space: nowrap;
        
            overflow: hidden;
            overflow-x: scroll;
            
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
        }

        .items::-webkit-scrollbar { 
            display: none;
        }

        .items:after {
             content: "";
             display: block;
             clear: both;
         }

        .item {
            display: inline-block;
            padding: 0px 7px;
            width: 80px;
            text-align: center;

            vertical-align: top;
            

            .circle {
                position: relative;
                display: inline-block;
                border-radius: 50%;
                width: 50px;
                height: 50px;

                img {
                    position: absolute;

                    top: 0px;
                    right: 0px;
                    bottom: 0px;
                    left: 0px;
                    margin: auto;

                    max-width: 20px;


                }
            }

            .circle.red {
                background: red;
            }

            .circle.orange {
                background: orange;
            }

            .circle.yellow {
                background: yellowgreen;
            }

            .circle.green {
                background: green;
            }

            .name {
                font-size: 12px;
                line-height: 1;
                white-space: normal;
            }
        }
    }
    
</style>